import { client } from "@/http/client"

import { IPagingResponse, IRequestParams, IResponse } from "@/types/api"
import {
  IAuthorities,
  IAuthoritiesCreate,
  IAuthoritiesUpdate,
  IAuthorityLogs,
  IAuthorityRegisterLogs
} from "@/types/IAuthorities"
import { IDownloadDocument } from "@/types/IDownloadDocument"
import { IDispatcherOrder } from "@/types/IOrder"
import {
  IAuthorityProcessLog
} from "@/types/IProcessLog"


export const getAuthorities = (
    params: IRequestParams
): Promise<IPagingResponse<IAuthorities>> =>
   client.get("/Authorities", {
       params
   })

export const getAuthoritiesById = (id: number): Promise<IResponse<IAuthorities>> =>
    client.get(`/Authorities/${id}`)

export const createAuthorities = (body: IAuthoritiesCreate) : Promise<IResponse<number>> =>
    client.post("/Authorities", body)

export const updateAuthorities = (body: IAuthoritiesUpdate): Promise<IResponse<string>> =>
    client.put("/Authorities", body)

export const deleteOrders = (ids: number[]): Promise<IResponse<boolean>> =>
    client.delete("/Authorities", {
      data: {
        ids
      }
    })

export const updateAuthoritiesFromSoap = (body: void) => client.put("/Authorities/update-from-soap")

export const getLastUpdateFromSoap = (body: void): Promise<IResponse<IAuthorityProcessLog>> =>
    client.get("/Authorities/last-update-from-soap")

export const getForAuthoritiesOrdersList = (authoritiesId: number | undefined): Promise<IPagingResponse<IDispatcherOrder>> =>
   client.get("/Authorities/orderList", {
      params: {
         authoritiesId
      }
   })

export const getAuthorityLogs = (params: IRequestParams): Promise<IPagingResponse<IAuthorityLogs>> =>
   client.get("/Authorities/logs", { params })

export const getAuthorityLogFileById = (logId: number): Promise<IDownloadDocument> =>
   client.get(`/Authorities/logs/${logId}`)

export const getAuthorityRegisterLogs = (params: IRequestParams): Promise<IPagingResponse<IAuthorityRegisterLogs>> =>
   client.get("/Authorities/register-logs", { params })

export const getAuthorityRegisterLogFileById = (logId: number): Promise<IDownloadDocument> =>
   client.get(`/Authorities/register-logs/${logId}`)